<template>
  <div class="business-desc">
    <nav-bar titleText="万融解债业务说明" titleWeight="bold" @goBack="goBack" :isFixed="true" ></nav-bar>
    <div class="business-desc-content" v-html="content">
    </div>
    <div class="button">
      <van-button size="large" round type="info" color="#FC740C" @click="toDebtHome">我已了解业务，进入解债首页</van-button>
    </div>
    <div class="contact-service" @click="chat">
      <span>我还需要进一步了解，立即联系客服</span>
      <div class="icon">
        <img src="../../assets/debtor/chevron.png" alt="">
      </div>
    </div>
    <div class="authenticate-popup">
      <van-dialog 
        v-model="show" 
        overlay
        width="280px"
        message="未完成实名认证"
        title="提示" 
        show-cancel-button
        :confirmButtonText=confirmText
        confirm-button-color="#F9591B"
        @confirm="confirmEvent"
      >
        <p class="tips" v-if="type == 0">未完成实名认证</p>
        <p class="tips" v-if="type == -1">实名认证失败</p>
      </van-dialog>
    </div>
    <van-popup v-model="show_ts" :close-on-click-overlay="false" overlay>
    	<div class="box">
    		<img src="../../assets/common/BG@2x.png" alt="" />
    		<p class="title">温馨提示</p>
    		<p class="tips">{{maintain_document}}！</p>
    		<span @click="goBacks()">好的</span>
    	</div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import navBar from "./components/navBar";
export default {
  data() {
    return {
      content: '',
      show: false,
      show_ts: false,
      maintain_document:'',
      type: 1, // -1认证失败  0 没有认证 1 认证成功
      confirmText:'',
    }
  },
  components: {
    navBar
  },
  created() {
    // console.log('已进入页面')
    
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    // 二期，认证粉丝
    if(this.$route.query.registerFrom){
      this.$api.post("/debt/member/agent/agent-update",{"agent_id":this.$route.query.registerFrom.split("_")[1]})
    }
    // alert(this.$route.query.registerFrom + '---------------------------------')
    this.$api.post('debt/member/setting/is-maintain', {}).then(data =>{
       if(data.maintain_status == '1'){
         this.show_ts = true;
         this.maintain_document =data.maintain_document
       }else{
         this.getBusinessDesc()
       }
    })
      
  },
  methods: {
    getBusinessDesc() {
      this.$api.get('cms-v2/index/agreement/app/detail', {number:'jzjjr'}).then(data =>{
        this.content = data.content
      })
    },
    chat() {
      this.params('18', '18', 'customerService')
    },
    toDebtHome(){
      this.$api.post('/debt/member/cert/is-cert')
      .then(data => {
        // 认证
        if (data.is_cert == 0 || !data.is_cert) {
          this.show = true
          this.type = 0
          this.confirmText = '前往认证'
          return 
        }
        if(data.is_cert == 1){
          this.$router.push({
            path: '/debtRelief/wrDebtPersonHome',
            query: {
              token: localStorage.getItem('_token') || this.$route.query.token
            }
          })
          return
        }
        if(data.is_cert == -1) {
          this.show = true
          this.type = -1
          this.confirmText = '再次认证'
          return
        }
      })
      .catch(err => {
        console.log(err)
        err.message && this.$toast(err.message)
      })
      
    },
    confirmEvent(){
      this.show = false,
      this.params("", "", "personal")
    },
    goBack() {
      this.params("home", "home", "goBack");
    },
    goBacks(){
      this.show_ts =false;
      this.params("", "", "goBack");
    }
  }
};
</script>

<style lang="less">
.business-desc {
  .business-desc-content {
    padding: 93px 12px 118px;
    .business-background {
      margin-bottom: 15px;
      .title {
        height: 26px;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 26px;
        margin-bottom: 5px;
      }
      .desc {
        height: 69px;
        font-size: 14px;
        color: #333333;
        line-height: 23px;
      }
    }
    .role-desc, .business-logic, .attention {
      .title {
        height: 26px;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 26px;
        margin: 15px 0 5px;
      }
      .desc {
        height: 92px;
        font-size: 14px;
        color: #333333;
        line-height: 23px;
      }
    }

  }

  .button {
    position: fixed;
    bottom: 60px;
    padding: 0 12px;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    // margin-bottom: 12px;
    .van-button__text {
      height: 28px;
      font-size: 17px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 28px;
    }

  }
  .contact-service {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    width: 100%;
    padding-bottom: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      margin-top: 12px;
      height: 23px;
      font-size: 14px;
      color: #F9591B;
      line-height: 23px;
      margin-right: 6px;
    }
    .icon {
      width: 8px;
      height: 13px;
      img {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
      }
    }

  }
  .van-dialog {
    border-radius: 8px;
    .van-dialog__header {
      height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      .van-button__text {
        height: 28px;
        font-size: 17px;
        color: #333333;
        line-height: 28px;
      }
    }
    .tips {
      padding: 15px 0 24px;
      text-align: center;
    }
  }
  .van-popup--center{
		width: calc(100% - 67px);
		border-radius: 10px;
		.box{
			img {
				display: block;
				width: 100%;
			}
			.title {
				color: #333;
				font-size: 15px;
				font-weight: 600;
				line-height: 47px;
				margin-top: 8px;
				text-align: center;
			}
			.tips {
				color: #333;
				font-size: 13px;
				line-height: 18px;
				text-align: center;
				margin-bottom: 30px;
			}
			span {
				width: 100%;
				border-top: solid 1px #F2F2F2;
				line-height: 43px;
				color: #E6212F;
				font-size: 14px;
				text-align: center;
				display: inline-block;
    }
    }
			}
}
</style>
